import React from 'react';
import useUser from '../../Hooks/useUser';
import { Link } from 'react-router-dom';
import LearningLayout from '../../LearningPlatform/LearningLayout';
import { FaEnvelope, FaKey, FaArrowLeft } from 'react-icons/fa';

function ForgotPassword() {
    const { email, setEmail, resetPassword } = useUser();

    const handleSubmit = (e) => {
        e.preventDefault();
        resetPassword();
    };

    return (
        <LearningLayout>
            <div className='flex-1 overflow-auto flex flex-col'>
                <div className='flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8'>
                    <div className='w-full max-w-md'>
                        {/* Form Card */}
                        <div className='bg-white/95 backdrop-blur-md rounded-2xl shadow-xl border border-white/50 overflow-hidden'>
                            {/* Header */}
                            <div className='bg-gradient-to-r from-violet-600 to-indigo-600 p-8 text-center'>
                                <div className='flex justify-center mb-4'>
                                    <div className='bg-white/20 backdrop-blur-sm p-4 rounded-full'>
                                        <FaKey className='text-4xl text-white' />
                                    </div>
                                </div>
                                <h1 className='text-3xl font-bold text-white mb-2'>Redefina sua senha</h1>
                                <p className='text-white/90 text-sm'>Informe o e-mail associado à sua conta para receber um link de redefinição de senha.</p>
                            </div>

                            {/* Form */}
                            <form onSubmit={handleSubmit} className='p-8'>
                                {/* Email Input */}
                                <div className='mb-6'>
                                    <label className='block text-sm font-medium text-gray-700 mb-2'>
                                        Email
                                    </label>
                                    <div className='relative'>
                                        <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                                            <FaEnvelope className='text-gray-400' />
                                        </div>
                                        <input
                                            type="email"
                                            placeholder="seu@email.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            className='w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-all duration-200 placeholder-gray-400'
                                        />
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    className='w-full bg-gradient-to-r from-violet-600 to-indigo-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-violet-700 hover:to-indigo-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02]'
                                >
                                    Continuar
                                </button>

                                {/* Back to Login Link */}
                                <div className='mt-6 text-center'>
                                    <Link
                                        to="/login"
                                        className='inline-flex items-center gap-2 text-gray-600 hover:text-violet-600 text-sm font-medium transition-colors'
                                    >
                                        <FaArrowLeft className='text-xs' />
                                        Voltar para Login
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </LearningLayout>
    );
}

export default ForgotPassword;
